import type { ComponentPropsWithoutRef } from 'react';
import { cn } from 'src/utils/cn';

type SpacerProps = { vertical?: boolean } & ComponentPropsWithoutRef<'div'>;

export const Spacer = ({ vertical, className, ...props }: SpacerProps) => {
  return (
    <div
      className={cn(
        vertical && 'mx-md h-full w-[0.1rem]',
        !vertical && 'my-md h-[0.1rem] w-full',
        className
      )}
      {...props}
    />
  );
};
